// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notice-wrap[data-v-6f2f341a]{width:100%;background-color:var(--black200);border-radius:8px;padding:12px;display:flex;flex-direction:column;gap:12px}.notice-item[data-v-6f2f341a]{font-size:14px;line-height:1.36;font-weight:400;color:var(--black700);position:relative;padding-left:18px;word-break:keep-all}.notice-item[data-v-6f2f341a]:before{content:\"•\";position:absolute;left:0}", ""]);
// Exports
module.exports = exports;
